/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcribe_After_Import_TitleInputs */



/**
* | output |
* | --- |
* | "Transcribe this media?" |
*
* @param {Transcribe_After_Import_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcribe_after_import_title = /** @type {((inputs?: Transcribe_After_Import_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcribe_After_Import_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Transcribe this media?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Transcribe this media?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Transcribe this media?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Transcribe this media?")
	if (locale === "es") return /** @type {LocalizedString} */ ("Transcribe this media?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Transcribe this media?")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Transcribe this media?")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Transcribe this media?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Transcribe this media?")
	return /** @type {LocalizedString} */ ("Transcribe this media?")
});